<template>
    <div class="page">
        <div class="page_content">
            <template v-if="lang === 1">
                <div class="en_top" data-aos="fade-down" data-aos-duration="500">
                    <div class="top_title_text">TOP DIGITAL CAMPAIGN AGENCY IN CHINA:</div>
                    <div class="top_content_text">Building impatful brands through the WeChat</div>
                    <div class="btn_contact" @click="onScrollContact">GET A FREE CONSULTATION</div>
                </div>
                <div class="intro_video">
                    <video controls autoplay loop muted src="https://deansel-1255566742.cos.ap-shanghai.myqcloud.com/deanselweb/intro.mp4" poster="https://deansel-1255566742.cos.ap-shanghai.myqcloud.com/deanselweb/video_poster.jpg"></video>
                </div>
                <div class="middle intro_part">
                    <div class="intro_title" data-aos="fade-down" data-aos-duration="500">Our Methodology</div>
                    <div class="intro_subtitle" data-aos="fade-down" data-aos-duration="500">Learn more about our Mobius Methodology™ of delivering eCommerce greatness in 3 simple steps.</div>
                    <div class="intro_box">
                        <div class="intro_item" data-aos="fade-down" data-aos-duration="500">
                            <div class="intro_item_title">Design</div>
                            <div class="intro_item_subtitle">Lay foundations</div>
                            <div class="intro_content">
                                <div class="intro_content_item">Insights</div>
                                <div class="intro_content_item">Brand Consultancy</div>
                                <div class="intro_content_item">Brand Strategy</div>
                                <div class="intro_content_item">Visual Identity</div>
                                <div class="intro_content_item">Brand Guidelines</div>
                            </div>
                        </div>
                        <div class="intro_item" data-aos="fade-down" data-aos-duration="500">
                            <div class="intro_item_title">Development</div>
                            <div class="intro_item_subtitle">Build your house</div>
                            <div class="intro_content">
                                <div class="intro_content_item">Mini-App Development</div>
                                <div class="intro_content_item">Custom Development</div>
                                <div class="intro_content_item">Mobile Apps & Web Apps</div>
                                <div class="intro_content_item">Integrations</div>
                                <div class="intro_content_item">IT Support</div>
                            </div>
                        </div>
                        <div class="intro_item" data-aos="fade-down" data-aos-duration="500">
                            <div class="intro_item_title">Marketing</div>
                            <div class="intro_item_subtitle">Invite people in</div>
                            <div class="intro_content">
                                <div class="intro_content_item">WeChat Marketing</div>
                                <div class="intro_content_item">CRM & Email Marketing</div>
                                <div class="intro_content_item">Campaign Planning</div>
                                <div class="intro_content_item">Socail CRM Marketing</div>
                                <div class="intro_content_item">Customer behavior tracking</div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="logo_part">
                    <div class="mid_title" data-aos="fade-down" data-aos-duration="500">Who we work with</div>
                    <div class="logo_box" >
                        <div class="logo_item" v-for="item in logos" :key="item" data-aos="fade-down" data-aos-duration="500">
                            <img :src="item" alt=""/>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="top">
                    <div class="top1">
                    <!-- <vue-typed-js v-if="cursorLine < 4" :strings="[`${text.top1[lang] + text.words[0][lang]}`]" @onComplete="onTypeComplete" :typeSpeed="100">
                            <span class="typing"></span>
                        </vue-typed-js> -->
                        <!-- <span class="words">
                            <transition :name="firstword ? 'firstwordflip' : 'wordflip'" v-for="(item, index) in text.words" :key="index">
                                <span v-if="cursorLine === 4 && wordIndex === index">{{item[lang]}}</span>
                            </transition>
                        </span>          -->
                        <vue-typed-js v-if="cursorLine === 1" :strings="[`${text.top1[lang] + text.words[0][lang]}`]" @onComplete="onTypeComplete" :typeSpeed="100">
                            <span class="typing"></span>
                        </vue-typed-js>
                        <span v-if="cursorLine > 1">{{`${text.top1[lang] + text.words[0][lang]}`}}</span>
                    </div>
                    <div class="top2" v-if="cursorLine > 1">
                        <vue-typed-js v-if="cursorLine === 2" :strings="[`${text.top2[lang]}`]" @onComplete="onTypeComplete" :typeSpeed="100">
                            <span class="typing"></span>
                        </vue-typed-js>
                        <span v-if="cursorLine > 2">{{text.top2[lang]}}</span>
                    </div>
                    <div class="top3" v-if="cursorLine > 2">
                        <vue-typed-js v-if="cursorLine === 3" :strings="[`${text.top3[lang]}`]" @onComplete="onTypeComplete" :typeSpeed="150">
                            <span class="typing"></span>
                        </vue-typed-js>
                        <span v-if="cursorLine > 3">{{text.top3[lang]}}</span>
                    </div>
                </div> 
                <div class="intro_video">
                    <video controls autoplay loop muted src="https://deansel-1255566742.cos.ap-shanghai.myqcloud.com/deanselweb/intro.mp4" poster="https://deansel-1255566742.cos.ap-shanghai.myqcloud.com/deanselweb/video_poster.jpg"></video>
                </div>
                <div class="middle midpart1" data-aos="fade-down" data-aos-duration="500">
                    <div class="mid_item1" v-for="(item, index) in text.midpart1" :key="index">{{item.content[lang]}}</div>
                </div>
            </template>
            <div class="middle">
                <div class="mid_title" data-aos="fade-down" data-aos-duration="500">{{text.midpart2.title[lang]}}</div>
                <div class="case_container">
                    <div class="case_item" data-aos="fade-down" data-aos-duration="500" :data-aos-delay="index % 2 * 200" v-for="(item, index) in text.midpart2.cases" :key="index">
                        <div class="case_img">
                            <img class="img_base" :src="item.img" alt="">
                        </div>
                        <div class="case_title">{{item.title[lang]}}</div>
                        <div class="case_content">{{item.content[lang]}}</div>
                    </div>
                </div>
            </div>
            <div class="middle5" data-aos="fade-down" data-aos-duration="500" v-if="lang === 0">
                <div class="mid_title">{{text.midpart3.title[lang]}}</div>
                <swiper class="swiper" ref="mySwiper" :options="swiperOptions">
                    <swiper-slide class="mid3_swiper_slide" v-for="(item, index) in text.midpart3.content" :key="index">
                        <div class="mid3_item" @click="toPage(item.url, item.routerUrl)">
                            <div class="mid3_img">
                                <img class="img_base" :src="item.img" alt="">
                            </div>
                            <div class="mid3_title">{{item.title[lang]}}</div>
                            <div class="mid3_content">{{item.content[lang]}}</div>
                        </div>
                    </swiper-slide>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
            <div class="middle4">
                <div class="mid_title" v-if="lang === 1">What our clients say</div>
                <div class="midpart4">
                    <div class="mid4_left" data-aos="fade-down" data-aos-duration="500">
                        <div class="mid4_left_title">{{text.midpart4.title[lang]}}</div>
                        <div class="mid4_left_content">{{text.midpart4.content[lang]}}</div>
                        <div class="mid4_btns">
                            <button class="btn_left" @click="onClickLeft"></button>
                            <button class="btn_right" @click="onClickRight"></button>
                        </div>
                    </div>
                    <swiper class="mid4_right" ref="reviewSwiper" :options="reviewSwiperOptions" data-aos="fade-down" data-aos-duration="500" data-aos-delay="300">
                        <swiper-slide class="mid4_swiper_slide" v-for="(item, index) in text.midpart4.reviews" :key="index">
                            <div class="mid4_swiper_slide_content">
                                <div class="mid4_right_name">{{item.name[lang]}}</div>
                                <div class="mid4_right_pos">{{item.pos[lang]}}</div>
                                <div class="mid4_right_content">{{item.content[lang]}}</div>
                                <div class="mid4_right_logo">
                                    <img class="img_base" :src="item.logo" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div> 
            </div>
            <div class="middle" v-if="lang === 1" id="contact">
                <div class="mid_title" data-aos="fade-down" data-aos-duration="500">Contact Us</div>
                <div class="contact_box" >
                    <div class="contact_left" data-aos="fade-down" data-aos-duration="500">
                        <div class="contact_title" >GET A FREE CONSULTATION</div>
                        <form ref="form" @submit.prevent="onSubmit">
                            <div class="input_row">
                                <div class="input_item">
                                    <div class="input_title">Name:</div>
                                    <input class="input_content" placeholder="Please input your name" type="text" name="name" v-model="info.name">
                                </div>
                                <div class="input_item">
                                    <div class="input_title">Company:</div>
                                    <input class="input_content" placeholder="Please input your company" type="text" name="company" v-model="info.company">
                                </div>
                            </div>
                            <div class="input_row">
                                <div class="input_item">
                                    <div class="input_title">Phone:</div>
                                    <input class="input_content" placeholder="Please input your phone" type="text" name="phone" v-model="info.phone">
                                </div>
                                <div class="input_item">
                                    <div class="input_title">E-mail:</div>
                                    <input class="input_content" placeholder="Please input your E-mail" type="text" name="mail" v-model="info.mail">
                                </div>
                            </div>
                             <div class="input_item">
                                <div class="input_title">Requirement:</div>
                                <input class="input_content" placeholder="Please input your requirement" type="text" name="requirement" v-model="info.requirement">
                            </div>
                            <button class="btn_send" :disabled="sendFlag" :class="{'disabled': sendFlag}">Send</button>
                        </form>
                    </div>
                    <div class="contact_right" data-aos="fade-down" data-aos-duration="500">
                        <div class="contact_title">CONTACT</div>
                        <div class="contact_subtitle">Deansel Co. Ltd</div>
                        <div class="contact_content">
                            <div class="site_item">
                                <div class="site_logo">
                                    <img src="../assets/images/logo_deansel.jpg" alt="">
                                </div>
                                <div class="site_info">
                                    <div class="site_city">Shanghai</div>
                                    <div class="site_text">Room 201, building 3, No 18. Jinhai Road, Pudong, Shanghai</div>
                                    <div class="site_mail">
                                        <a class="site_mail_text"  href="mailto:info@deansel.com">info@deansel.com</a>
                                    </div>
                                    <div class="site_text">+86-18601623461</div>
                                </div>
                            </div>
                            <div class="site_item">
                                <div class="site_logo">
                                    <img src="../assets/images/logo_deansel.jpg" alt="">
                                </div>
                                <div class="site_info">
                                    <div class="site_city">Taipei</div>
                                    <div class="site_text">No. 97 & 101, Songren Road Xinyi District Taipei</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Foot/>
        <Nav/>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import Nav from '@/components/Nav.vue'
import Foot from '@/components/Foot.vue'
import {homeText} from '@/js/text.js'
import {wxShare} from '@/js/api.js'
import { setInterval, clearInterval } from 'timers'
import fetch from 'node-fetch';
export default {
    components: {
        Nav,
        Foot,
        Swiper,
        SwiperSlide
    },
    data () {
        return {
            info: {
                name: '',
                phone: '',
                company: '',
                mail: '',
                requirement: ''
            },
            text: homeText,
            swiperOptions: {
                speed: 500,//切换速度
                loop: true,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            },
            reviewSwiperOptions: {
                speed: 500,//切换速度
                loop: true,
                slidesPerView : 2
            },
            cursorLine: 1, // 初始值1
            wordIndex: 0,
            firstword: true,
            logos: [
                require('../assets/images/company_logo_1.png'),
                require('../assets/images/company_logo_2.png'),
                require('../assets/images/company_logo_3.png'),
                require('../assets/images/company_logo_4.png'),
                require('../assets/images/company_logo_5.png'),
                require('../assets/images/company_logo_6.png'),
                require('../assets/images/company_logo_7.png'),
                require('../assets/images/company_logo_8.png'),
                require('../assets/images/company_logo_9.png'),
                require('../assets/images/company_logo_10.png'),
                require('../assets/images/company_logo_11.png'),
                require('../assets/images/company_logo_12.png'),
                require('../assets/images/company_logo_13.png'),
                require('../assets/images/company_logo_14.png'),
                require('../assets/images/company_logo_15.png'),
                require('../assets/images/company_logo_16.png'),
                require('../assets/images/company_logo_17.png'),
                require('../assets/images/company_logo_18.png'),
            ],
            sendFlag: false,
        }
    },
    computed: {
        lang () {   // 0中文，1英文
            return this.$store.state.lang
        },
        swiper () {
            return this.$refs.mySwiper.$swiper
        },
        reviewswiper () {
            return this.$refs.reviewSwiper.$swiper
        },
        wordSwiper () {
            return this.$refs.wordSwiper.$swiper
        }
    },
    methods: {
        showMessage () {
            this.$alert('文章尚在开发中，敬请期待', '提示', {
                confirmButtonText: '确定'
            })
        },
        toPage (url, routerUrl) {
            if (url !== '') {
                window.open(url)
            } else if (routerUrl !== '') {
                if (this.$route.path !== routerUrl) {
                    this.$router.push({path: routerUrl})
                }
            } else {
                this.showMessage()
            }
            
        },
        onClickLeft () {
            this.reviewswiper.slidePrev()
        },
        onClickRight () {
            this.reviewswiper.slideNext()
        },
        onTypeComplete () {
            this.cursorLine += 1
            let self = this
            if (this.cursorLine === 4) {
                self.firstword = false
                self.wordIndex = (self.wordIndex + 1) % self.text.words.length
                this.wordInterval = setInterval(() => {
                    self.firstword = false
                    self.wordIndex = (self.wordIndex + 1) % self.text.words.length
                }, 3000)
            }
        },
        async sendInfo (info) {
            try {
                const reqUrl = process.env.NODE_ENV === "development" ? '/mailsender/contact' : 'https://wxshare.prod.deansel.com/mailsender/contact'
                let response = await fetch(reqUrl, {
                    method: 'POST',
                    body: JSON.stringify(info),
                    headers: new Headers({
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json'
                    }),
                    mode: 'cors'
                })
                if (response.status === 200) {
                    this.$alert('Send successfully.').catch(e => e)
                    return await response.json()
                } else {
                    this.$alert('This service is blocked, please contact us by email or phone.').catch(e => e)
                }  
            } catch {
                this.$alert('This service is blocked, please contact us by email or phone.').catch(e => e)
            }
            },
        async onSubmit () {
            if (!this.info.name) {
                this.$alert('Please input your name.').catch(e => e)
            }
            else if (!(this.info.phone || this.info.mail)) {
                this.$alert('Please input your phone or e-mail.').catch(e => e)
            } else if (!this.info.requirement) {
                this.$alert('Please input your requirement.').catch(e => e)
            } else {
                this.sendFlag = true
                await this.sendInfo(this.info)
                this.sendFlag = false
            }
        },
        onScrollContact () {
            const contact = document.getElementById('contact')
            contact.scrollIntoView()
        }
    },
    mounted () {
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '用户', '进入', '首页'])
        const url = location.href
        var shareInfo = {
            title: '为客户提供增长落地方案',
            desc: 'Deansel专注于解决客户在新生态下的增长方案'
        }
        wxShare(url, shareInfo)
    },
    destroyed () {
        if (this.wordInterval) {
            clearInterval(this.wordInterval)
        }
    }
}
</script>

<style scoped>
.top {
    width: 100%;
    height: 100vh;
    background: linear-gradient(0.02turn, #2C345B, #32343B);
    position: relative;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.top1 {
    max-width: 80%;
    margin-left:10%;
    font-size: 2.5vw;
    color: #fff;
    font-weight: bold;
    display: flex;
    align-items: center;
}
.top1 span {
    height: 3.75vw;
    line-height: 3.75vw;
}
.words {
    width: 20vw;
    position: relative;
}
.words span {
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: left center;
}
.wordflip-enter-active {
  transition: all .3s ease-in;
}
.wordflip-leave-active {
  transition: all .3s ease-in;
}
.wordflip-enter {
    transform: translateY(100%) scaleY(0);
    /* opacity: 0; */
}
.wordflip-leave-to{
  transform: translateY(-100%) scaleY(0);
  /* opacity: 0; */
}
.firstwordflip-enter-active {
  transition: all 0s ease-in;
}
.firstwordflip-leave-active {
  transition: all .3s ease-in;
}
.firstwordflip-leave-to{
  transform: translateY(-100%) scaleY(0);
  /* opacity: 0; */
}
.top2 {
    width: 80%;
    margin: 2% 10%;
    font-size: 7.5vw;
    color: #FFCA0E;
    font-weight: bold;
}
.top3 {
    width: 80%;
    margin-left:10%;
    font-size: 2.5vw;
    color: #fff;
    font-weight: bold;
}
.en_top {
    width: 100%;
    height: 100vh;
    background: linear-gradient(0.02turn, #2C345B, #32343B);
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 500;
}
.top_title_text {
    width: 90vw;
    font-size: 3rem;
    line-height: 1.5;
}
.top_content_text {
    width: 90vw;
    font-size: 2.25rem;
    margin-top: 2%;
}
.btn_contact {
    position: absolute;
    bottom: 4rem;
    left: 50%;
    transform: translateX(-50%);
    padding: 12px 24px;
    border: 1px #fff solid;
    color: #fff;
    text-decoration: none;
    margin-top: 10vw;
    font-weight: bold;                                                                                                                                                                 
}
.btn_contact:hover {
    cursor: pointer;
}
.intro_video {
    width: 100vw;
    height: 56.25vw;
}
.intro_video video{
    width: 100%;
    height: 100%;
    /* object-fit: cover; */
}
.intro_part {
    text-align: left;
}
.intro_title {
    width: 100%;
    font-size: 1.5rem;
    font-weight: bold;
}
.intro_subtitle {
    width: 100%;
    font-size: 1.125rem;
    margin-top: 2%;
}
.intro_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 5%;
}
.intro_item {
    max-width: 26vw;
}
.intro_item_title {
    width: 100%;
    font-size: 1.5rem;
    font-weight: 500;
}
.intro_subtitle, .intro_item_subtitle {
    width: 100%;
    font-size: 1.125rem;
}
.intro_content {
    margin-top: 2vw;
    font-weight: 500;
}
.intro_content_item {
    margin-top: 1vw;
}
.logo_part {
    width: 84%;
    margin: 10% auto;

}
.logo_box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: center;
}
.logo_item {
    width: 14vw;
    height: 6.5vw;
    padding: 10px;
    box-sizing: border-box;
}
.logo_box img {
    width: 100%;
}
.logo_box img:hover{
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}
.middle {
    width: 80%;
    margin: 10%;
    line-height: 1.5;
}
.middle5 {
    width: 80%;
    margin: 10%;
    line-height: 1.5;
}
.mid_title {
    width: 100%;
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 5%;
    text-align: center;
}
.midpart1 {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    text-align: left;
    font-size: 1.125rem;
}
.mid_item1 {
    width: 30vw;
}
.mid_item1:nth-child(1) {
    margin-right: 6vw;
}
.case_container {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
}
.case_item {
    width: 38vw;
    margin: 0 4vw 2vw 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.case_item:nth-child(2n) {
    margin: 0 0 2vw 0;
}
.case_img {
    width: 100%;
    height: 24vw;
    background: #D8D8D8;
}
.case_title {
    width: 80%;
    font-size: 0.875rem;
    font-weight: bold;
    margin: 3vw auto 2vw auto;
}
.case_content {
    width: 80%;
    font-size: 0.875rem;
    margin-bottom: 2vw;
    
}
.swiper {
    width: 100%;
    height: 48vw;
    padding: 10px 0;
    /* box-sizing: border-box; */
}
.mid3_swiper_slide {
    width: 100%;
    height: 100%;
    font-size: 0.875rem;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
}
.mid3_item {
    width: 64vw; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.mid3_item:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    cursor: pointer;
}
.mid3_img {
    width: 60vw;
    height: 30vw;
    background: #D8D8D8;
}
.mid3_title {
    width: 60vw;
    font-size: 0.875rem;
    font-weight: bold;
    margin: 3vw auto 2vw auto;
}
.mid3_title:hover {
    text-decoration: underline;
    color: #1F40E6;
    cursor: pointer;
}
.mid3_content {
    width: 60vw;
    font-size: 0.875rem;
    margin-bottom: 2vw;
}
.swiper-container{
    --swiper-theme-color: #cccccc;/* 设置Swiper风格 */
    --swiper-navigation-color: #D8D8D8;/* 单独设置按钮颜色 */
    --swiper-navigation-size: 16px;/* 设置按钮大小 */
}
.swiper-button-prev, .swiper-button-next {
    background: #2C3559;
    border-radius: 100%;
    width: 30px;
    height: 30px;
}
.middle4 {
    width: 85%;
    margin: 10% 5% 10% 10%;
    line-height: 1.5;
}
.midpart4 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.mid4_left {
    width: 30vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: left;
}
.mid4_left_title {
    width: 100%;
    font-size: 1.5rem;
    font-weight: bold;
}
.mid4_left_content {
    font-size: 0.875rem;
    width: 100%;
    margin: 3vw auto;
}
.mid4_btns {
    width: 40%;
    display: flex;
    justify-content: space-between;
}
.btn_left, .btn_right {
    width: 30px;
    height: 30px;
    background: #2C3559;
    border-radius: 100%;
}
@font-face {
  font-family: 'swiper-icons';
  src: url("data:application/font-woff;charset=utf-8;base64, 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") format("woff");
  font-weight: 400;
  font-style: normal;
}
.btn_left::after {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    text-align: center;
    color: #fff;
    content: 'prev';
    font-family: 'swiper-icons';
}
.btn_right::after {
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    content: 'next';
    font-size: 16px;
    font-family: 'swiper-icons';
}
.mid4_right {
    width: 50vw;
    margin: 0;
}
.mid4_swiper_slide {
    padding: 4vw 8px;
    box-sizing: border-box;
}
.mid4_swiper_slide_content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: #F4FAFF;
    text-align: left;
    position: relative;
    transform: scale(0.8);
    color: rgba(0, 0, 0, 0.5);
    opacity: 0.7;
    transform-origin: bottom center;
}
.swiper-slide-active .mid4_swiper_slide_content{
    color: #000;
    transform: scale(1);
    opacity: 1;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}
.swiper-slide-active .mid4_right_logo {
    box-shadow: 0 0 5px #A2BED5;
}
.mid4_right_logo {
    width: 7vw;
    height: 7vw;
    background: #FFCA0E;
    border-radius: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%); 
}
.mid4_right_name {
    width: 80%;
    margin-left: 10%;
    font-size: 0.875rem;
    font-weight: bold;
    margin-top: 2vw;
}
.mid4_right_pos {
    width: 80%;
    margin-left: 10%;
    font-size: 0.8rem;
    transform: scale(0.8);
    transform-origin: left;
}
.mid4_right_content {
    width: 80%;
    margin-left: 10%;
    font-size: 0.875rem;
    margin-bottom: 2vw;
    font-weight: bold;
}
.contact_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    text-align: left;
}
.contact_left {
    flex: 1; 
}
.contact_title {
    font-size: 1.125rem;
    font-weight: 500;
}
.input_row {
    display: flex;
}
.input_item {
    flex: 1;
    margin-top: 2%;
    font-size: 0.875rem;
}
.input_item + .input_item {
    margin-left: 5%;
}
.input_title {
    width: 100%;
}
.input_content {
    width: 100%;
    padding: 10px;
    border: 1px solid #31373e;
    box-sizing: border-box;
}
.btn_send {
    width: 100%;
    padding: 12px;
    background-color: #31373e;
    color: #fff;
    box-sizing: border-box;
    margin-top: 5%;
    font-weight: bold;
}
.disabled {
    opacity: 0.6;
}
.contact_right {
    width: 35%;
    margin-left: 5%;
}
.contact_subtitle {
    font-size: 1rem;
    font-weight: bold;
    margin-top: 5%;
}
.contact_content {
    /* margin-top: 5%; */
}
.site_item {
    display: flex;
    margin-top: 5%;
}
.site_logo {
    width: 1rem;
    height: 1rem;
    border-radius: 100%;
    overflow: hidden;
    line-height: 1;
    margin-top: 0.2rem;
}
.site_logo img {
    width: 100%;
}
.site_info {
    flex: 1;
    margin-left: 3%;
}
.site_city{
    font-size: 1rem;
    font-weight: bold;
}
.site_mail {
    width: 100%;
    margin-top: 5%;
    font-size: 1rem;
    font-weight: bold;
}
.site_mail_text {
    color: #000000;
    text-decoration: none;
}
.site_text {
    font-size: 0.875rem;
    margin-top: 2%;
}
@media screen and (max-width: 756px) {
    .top1 {
        max-width: 90%;
        font-size: 4vw;
    }
    .top1 span {
        height: 5vw;
        line-height: 5vw;
    }
    .words {
        width: 25vw;
        position: relative;
    }
    .top2 {
        font-size: 12vw;
    }
    .top3 {
        font-size: 4vw;
    }
    .midpart1 {
        flex-direction: column;
    }
    .mid_item1 {
        width: 100%;
    }
    .mid_item1:nth-child(1) {
        margin-bottom: 6vw;
    }
    .case_item {
        width: 100%;
        margin: 0 0 4vw 0;
    }
    .case_item:nth-child(2n) {
        margin: 0 0 4vw 0;
    }
    .case_img {
        width: 100%;
        height: 50vw;
    }
    .middle5 {
        width: 100%;
        margin: 10% 0;
        line-height: 1.5;
    }
    .swiper {
        width: 100%;
        height: 60vw;
    }
    .mid3_item {
        width: 74vw; 
    }
    .mid3_img {
        width: 70vw;
        height: 35vw;
    }
    .mid3_title {
        width: 70vw;
    }
    .mid3_content {
        width: 70vw;
    }
    .middle4 {
        width: 80%;
        margin: 10%;
    }
    .midpart4 {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }
    .mid4_left {
        width: 100%;
        margin-bottom: 5%;
        text-align: center;
    }
    .mid4_btns {
        width: 30%;
    }
    .mid4_right {
        width: 100%;
        margin: 0;
    }
    .mid4_swiper_slide {
        padding: 6vw 8px;
        box-sizing: border-box;
    }
    .mid4_right_logo {
        width: 10vw;
        height: 10vw;
    }
    .logo_part {
        width: 78%;
    }
    .logo_item {
        width: 26vw;
        height: 12vw;
        padding: 10px;
        box-sizing: border-box;
    }
    .contact_box {
        width: 100%;
        display: block;
        justify-content: space-between;
        text-align: left;
    }
    .contact_right {
        width: 100%;
        margin-left: 0;
        margin-top: 8%;
    }
    .contact_subtitle {
        margin-top: 5%;
    }
}
</style>


